export function KpiCard({ label, value, delta, deltaPositive, hint, highlight }) {
  return (
    <div className={`kpi-card${highlight ? " kpi-card--accent" : ""}`}>
      <span className="kpi-card__label">{label}</span>
      <div className="kpi-card__row">
        <span className="kpi-card__value">{value}</span>
        {delta != null && delta !== "" && (
          <span
            className={`kpi-card__delta ${deltaPositive === false ? "is-negative" : "is-positive"}`}
          >
            {delta}
          </span>
        )}
      </div>
      {hint && <span className="kpi-card__hint">{hint}</span>}
    </div>
  );
}
